const CHALLENGE_FRIENDS_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/challengeFriendsFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/challengeFriendsFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/challengeFriendsFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default CHALLENGE_FRIENDS_FEATURE
